interface HeroProps {
  onStartDiagnosis: () => void;
}

export default function Hero({ onStartDiagnosis }: HeroProps) {
  return (
    <section className="pt-24 pb-16 md:pt-32 md:pb-24 bg-gradient-to-b from-red-50 to-white">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
        <div className="inline-flex items-center gap-2 bg-red-100 text-red-700 px-4 py-2 rounded-full text-sm font-semibold mb-6">
          <i className="ri-sparkling-line"></i>
          <span>完全無料・3分で完了</span>
        </div>

        <h1 className="text-3xl md:text-5xl font-bold text-gray-900 mb-6 leading-tight">
          3つの質問で、<br className="md:hidden" />
          あなたに最適な<br />
          クレジットカードが見つかる
        </h1>

        <p className="text-base md:text-lg text-gray-600 mb-10 max-w-2xl mx-auto leading-relaxed">
          年会費・還元率・審査不安など、あなたの条件に合わせておすすめカードを提案します。<br className="hidden md:block" />
          完全無料で診断できます。
        </p>

        <button
          onClick={onStartDiagnosis}
          className="bg-red-600 text-white px-10 py-4 rounded-full text-lg font-bold hover:bg-red-700 transition-all duration-300 shadow-lg hover:shadow-xl whitespace-nowrap inline-flex items-center gap-3"
        >
          <i className="ri-questionnaire-line text-2xl"></i>
          <span>無料で診断スタート</span>
        </button>

        <div className="mt-12 grid grid-cols-3 gap-4 md:gap-8 max-w-2xl mx-auto">
          <div className="text-center">
            <div className="w-12 h-12 md:w-16 md:h-16 bg-red-100 rounded-full flex items-center justify-center mx-auto mb-3">
              <i className="ri-time-line text-xl md:text-2xl text-red-600"></i>
            </div>
            <p className="text-xs md:text-sm font-semibold text-gray-900">3分で完了</p>
          </div>
          <div className="text-center">
            <div className="w-12 h-12 md:w-16 md:h-16 bg-red-100 rounded-full flex items-center justify-center mx-auto mb-3">
              <i className="ri-shield-check-line text-xl md:text-2xl text-red-600"></i>
            </div>
            <p className="text-xs md:text-sm font-semibold text-gray-900">完全無料</p>
          </div>
          <div className="text-center">
            <div className="w-12 h-12 md:w-16 md:h-16 bg-red-100 rounded-full flex items-center justify-center mx-auto mb-3">
              <i className="ri-user-heart-line text-xl md:text-2xl text-red-600"></i>
            </div>
            <p className="text-xs md:text-sm font-semibold text-gray-900">最適なカード</p>
          </div>
        </div>
      </div>
    </section>
  );
}
